import { useQuery } from '@tanstack/react-query';

import { getUpdateTemplate } from '../api/getUpdateTemplate';

export const useUpdateTemplate = (type: string) => {
  const query = useQuery({
    queryKey: ['update-template', type],
    queryFn: async () => {
      const response = await getUpdateTemplate(type);

      return response.data;
    },
    enabled: !!type
  });

  return query;
};
